

import React from 'react';
import axios from 'axios';


import Image from 'react-bootstrap/Image';
import ToyotaLogo from '../../../../static/images/ty-login-logo.png'
import Loader from '../../../../static/images/loading.gif'
import AppVars from '../../../../AppVars.js'
import Logger from '../../../../Logger.js';
import { constants } from '../../../../constants/constants';


const appVars = AppVars.getInstance();

class EmailSentView extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            ...props,

        }
 
    }

    render() {
        return(
            <div>               
                <div role="banner">
                <div>
                <a href = {appVars.getAppHomeURL(this.props.style)}><Image className="login-log-resend" src={require('../../../../static/images/Toyota-Logo.svg').default} alt="Toyota"/></a>
                </div>
                <h1 className="title__TO block" style={{'marginBottom': '29px', 'marginTop': '150px', 'width':'auto'}}>
                    {constants.RESET_EMAIL_SENT_TITLE}
                </h1>
                </div>
                {/* BODY OF THE COMPONENT */}
                <div role = "main" className="body-container__TO">
                    {/* Password State: EMAIL SENT */}
                    <div>
                        <div className="message__TO successMessage">Password reset link has been successfully sent to the email address below.</div>    
                        <div className="subTitle__TO">{this.props.email}</div>
                        <div className="linkTitle">Didn't get it?
                            <a className="resend-link" onClick={this.props.sendEmail}> We'll resend it.</a>
                        </div>
                    </div>

                </div>

                <div className={`${this.props.loadingReset === true ? "resend-background" : "none" }`}>
                    <div className="spinner">
                        <img className='spinner-img' src={Loader} alt="Loading"/>
                    </div>
                </div>
            </div>
        )
    }
}

export default EmailSentView;